import TextInput from '~/components/TextInput';
import { useState } from 'react';
import TextInputWithInlineLabel from '~/components/TextInputWithInlineLabel';
import CertificateIcon from '~/components/icons/CertificateIcon';
import { XMarkIcon } from '@heroicons/react/24/outline';

export function getCodesFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);

    const code = urlParams.get('code');
    if (code) {
        return [code];
    } else {
        return [];
    }
}

const CouponInput = ({ paymentParams, onChangePaymentParams }) => {
    const [localCoupon, setLocalCoupon] = useState('');
    const appliedCodes = paymentParams?.codes || [];

    function applyCoupon() {
        const newCodes = [
            ...appliedCodes,
            localCoupon
        ].filter((value, index, array) => {
            return array.indexOf(value) === index;
        });

        onChangePaymentParams({ ...paymentParams, codes: newCodes });
        setLocalCoupon('');
    }

    function clearCoupon(codeToRemove) {
        const newCodes = appliedCodes.filter((code) => code !== codeToRemove)
        onChangePaymentParams({ ...paymentParams, codes: newCodes });
    }



    return (
        <div>
            {!!appliedCodes?.length && (
                <div>
                    {appliedCodes.map((appliedCode) => (
                        <div className="flex items-center space-x-4">
                            <div className="my-2 font-semibold">
                                Applied: {appliedCode}
                            </div>
                            <button
                                type="button"
                                className="text-red-600"
                                onClick={() => clearCoupon(appliedCode)}
                            >
                                <XMarkIcon className="w-4 h-4" />
                            </button>
                        </div>
                    ))}
                </div>
            )}
            <TextInputWithInlineLabel
                onChange={setLocalCoupon}
                value={localCoupon}
                placeholder="Coupon or gift code..."
                inputClassName="pl-10 py-3"
                prefix={<CertificateIcon className="themed-text" />}
                suffix={
                    <>
                        {!!localCoupon && (
                            <button
                                type="button"
                                className="form-button btn-small py-2"
                                onClick={applyCoupon}
                            >
                                Apply
                            </button>
                        )}
                    </>
                }
            />
        </div>
    );
};

export default CouponInput;
